import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewChild
} from '@angular/core';
import insertTextAtCursor from 'insert-text-at-cursor';
import { PreviewEditTemplateService } from './state/preview-edit-template.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { TemplateUpdateModel } from './state/preview-edit-template.reducer';
import { PreviewEditTemplateSelectors } from './state/preview-edit-template.selectors';
import { filter, map } from 'rxjs/operators';
import { PreviewEditTemplateActions } from './state/preview-edit-template.actions';

@Component({
    templateUrl: './preview-edit-template-context.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PreviewEditTemplateContextComponent implements AfterViewInit {

    @Input() label: string;
    updatedModel = undefined;
    @ViewChild('comRef') comRef: ElementRef;

    constructor(private previewEditTemplateService: PreviewEditTemplateService,
                private store: Store<any>,
                private previewEditSelector: PreviewEditTemplateSelectors) {
        this.previewEditSelector.selectTemplateUpdateModel()
            .pipe(
                filter(templateUpdateMode => templateUpdateMode.updatedModel !== undefined)
            ).subscribe(templateUpdateMode =>
                this.updatedModel = {...templateUpdateMode.updatedModel}
            );
    }

    tooltip = 'Context based parameter that will be replaced when sending each message'; // TODO: display when fixed

    removeVariable(event): void {
        try {
            const templateContextElement = this.comRef.nativeElement.parentElement;
            let templateContext;
            if (templateContextElement.parentElement.attributes['id'] !== undefined) {
                templateContext = templateContextElement.parentElement.attributes['id'].nodeValue;
            } else  {
                // for emailcontent
                let parentElement = templateContextElement.parentElement;
                while (parentElement.attributes['contenteditable'] === undefined) {
                    parentElement = parentElement.parentElement;
                }
                templateContext = parentElement.attributes['ng-model'] !== undefined ?
                            parentElement.attributes['ng-model'].nodeValue : parentElement.attributes['id'].nodeValue;
            }
            if (templateContextElement.parentElement !== undefined && templateContextElement.parentElement !== null) {

                this.removeTemplateContextElement(templateContextElement);

                if (templateContext !== undefined) {
                    this.updatedModel[templateContext.split('.')[1]] = document.getElementById(templateContext).innerHTML;
                }
                // fix for removing template context parameter
                 this.updateTemplateModel(this.updatedModel);
            }
        } catch(e) {
            event.preventDefault();
        }
        event.stopPropagation();
    }

    onEvent(event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    onClick(event): void {
    }

    ngAfterViewInit(): void {
        if (this.comRef.nativeElement.parentElement.attributes['contenteditable'] === undefined) {
            this.comRef.nativeElement.parentElement.setAttribute('contenteditable',  'false');
        }
    }

    updateTemplateModel(updatedModel: any) : void {
        const templateUpdateModel = {
            updatedModel,
            isModelUpdated: true,
            updateType : 'model',
            type: ''
        };

        this.store.dispatch(
            PreviewEditTemplateActions.templateUpdateModel({
                templateUpdateModel,
            })
        );
    }


    private removeTemplateContextElement(templateContextElement: Element):void{
      if(templateContextElement.parentElement.id === "PARAMETER"){
        templateContextElement.parentElement.remove();
      }else {
        templateContextElement.parentElement.removeChild(templateContextElement);
      }
    }
}
